import { createFileRoute } from "@tanstack/react-router";
import { GoldCityAliasPage } from "@/components/GoldCityAliasPage";
import { GOLD_CITY_ALIASES, goldCityAliasMeta } from "@/lib/alias-routes";
import { getGoldCityVideo } from "@/lib/video-embeds";
import { makeAliasHead, makeAliasLoader } from "@/lib/alias-route-helpers";

const A = GOLD_CITY_ALIASES.find((x) => x.slug === "gold-rate-mumbai")!;
const M = goldCityAliasMeta(A);
const FB = getGoldCityVideo("gold-rate-mumbai");

export const Route = createFileRoute("/gold-rate-mumbai")({
  head: makeAliasHead(M, FB),
  loader: makeAliasLoader("gold-rate-mumbai", FB),
  component: () => <GoldCityAliasPage alias={A} h1={M.h1} />,
});
